import React from 'react';

import { useQuery } from '@betterment/js-runtime';

interface AppFooterContext {
  data: AppFooterData | null;
  loading: boolean;
}

export interface AppFooterData {
  terms: {
    advertisingDisclosure: HTMLString;
    apyDailyRateDisclosure: HTMLString;
    bondInvestingDisclosure: HTMLString;
    brokerageServicesDisclosure: HTMLString;
    checkingCashbackDisclosure: HTMLString;
    checkingDisclosure: HTMLString;
    everydayCheckingDisclosure: HTMLString;
    fdicDisclosure: HTMLString;
    goalCustomImageDisclosure: HTMLString;
    investmentAdvisorDisclosure: HTMLString;
    investmentInSecuritiesDisclosure: HTMLString;
    premiumManagementFeeDisclosure: HTMLString;
    privatePolicyLink: HTMLString;
    termsAndConditionsLink: HTMLString;
    trademarksLink: HTMLString;
    trustAndWillEstatePlanningDisclosure: HTMLString;
    rolloverBannerDisclosure?: HTMLString;
  };
}

type HTMLString = string;

export const FooterContext = React.createContext<AppFooterContext>({ data: null, loading: false });

export const FooterProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { data, loading } = useQuery<AppFooterData>('/api/v2/disclosures');
  const values = React.useMemo(() => ({ data, loading }), [data, loading]);
  return <FooterContext.Provider value={values}>{children}</FooterContext.Provider>;
};

export const useFooter = (): AppFooterContext => React.useContext(FooterContext);
